// extracted by mini-css-extract-plugin
module.exports = {"root":"PillsRow_root__yVWQ1","wrap":"PillsRow_wrap__6WnFz","layer":"PillsRow_layer__9ZVzu","animWrap":"PillsRow_animWrap__bCRg0"};